import axios from 'axios';
let service = axios.create({
    // 基本地址
    // baseURL: 'http://114.115.168.87:39888/api',
    // baseURL: 'http://henanmingxun.com/api',
    baseURL: 'http://webapi.henanmingxun.com/api',
    timeout: 5000
});

export default service;